import script from "./MotorControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./MotorControls.vue?vue&type=script&setup=true&lang=ts"

import "./MotorControls.vue?vue&type=style&index=0&id=1b1d4be0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1d4be0"]])

export default __exports__